import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';
import Moment from 'react-moment';
import { URL } from '../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { formatPontos } from '../../util/numberUtil';

export class ModalViagensClientePontos extends Component {
    constructor(props) {
        super(props);
        this.state = { viagens: [], carregando: false };
        this.fecharModal = this.fecharModal.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.cliente && this.props.cliente !== prevProps.cliente) {
            this.carregarViagens(this.props.cliente.id);
        }
    }

    carregarViagens(clienteId) {
        this.setState({ carregando: true, viagens: [] });
        axios.get(`${URL}/cliente/${clienteId}/viagens`, SLOW_REQUEST_CONFIG)
            .then(resp => this.setState({ viagens: resp.data || [] }))
            .catch(() => this.setState({ viagens: [] }))
            .finally(() => this.setState({ carregando: false }));
    }

    fecharModal() {
        $('#modalViagensClientePontos').modal('hide');
        $('#modalViagensClientePontos').hide();
        $('.modal-backdrop').hide();
        this.setState({ viagens: [] });
    }

    render() {
        const { cliente } = this.props;
        const { viagens, carregando } = this.state;

        return (
            <div className="modal fade show" id="modalViagensClientePontos" role="dialog"
                aria-labelledby="modalViagensClientePontos" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content vx-modal-content">

                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">list_alt</i>
                                <span className="vx-modal-title">
                                    Viagens{cliente ? ` — ${cliente.nome}` : ''}
                                </span>
                            </div>
                            <button type="button" className="vx-modal-close" onClick={this.fecharModal}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>

                        <div className="vx-modal-body">
                            {carregando ? (
                                <div className="vx-empty-state">
                                    <i className="material-icons">hourglass_empty</i>
                                    <p>Carregando viagens...</p>
                                </div>
                            ) : viagens.length > 0 ? (
                                <div className="vx-table-scroll">
                                    <table className="vx-table-left">
                                        <thead>
                                            <tr>
                                                <th>Data</th>
                                                <th>Origem</th>
                                                <th>Destino</th>
                                                <th>Valor</th>
                                                <th>Pontos</th>
                                                <th>Situação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {viagens.map((v, i) => (
                                                <tr key={i}>
                                                    <td><Moment format="DD/MM/YYYY">{v.dataViagem}</Moment></td>
                                                    <td>{v.origem}</td>
                                                    <td>{v.destino}</td>
                                                    <td>{v.valorPassagem}</td>
                                                    <td>
                                                        <span className="vx-pts-badge vx-pts-badge--green">
                                                            <i className="material-icons" style={{ fontSize: 11 }}>star</i>
                                                            {formatPontos(v.pontos)}
                                                        </span>
                                                    </td>
                                                    <td>{v.situacao}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="vx-empty-state">
                                    <i className="material-icons">directions_bus</i>
                                    <p>Nenhuma viagem encontrada para este cliente.</p>
                                </div>
                            )}
                        </div>

                        <div className="vx-modal-footer">
                            <button type="button" className="vx-btn-secondary" onClick={this.fecharModal}>
                                Fechar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default ModalViagensClientePontos;
